import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';
import { scroller } from 'react-scroll';

import { lighten } from '../../shared/color';
import dt from '../../shared/theme';
import IconedButton from './iconed-button';

const Button = styled(IconedButton)`
  background-color: ${props => lighten(dt(props).theme.primaryColor, 0.4)};
  outline: none;

  &:hover {
    background-color: ${props => lighten(dt(props).theme.primaryColor, 0.13)};
  }

  & > span.icon-lw {
    font-size: 16px;
    padding: 5px;
    background-color: ${props => dt(props).theme.primaryColor};
  }

  &.pale,
  &.pale:hover {
    background-color: white;
    border: 1px solid ${props => dt(props).theme.secondaryColor};
    color: ${props => dt(props).theme.bodyColor};
  }

  & > span.icon-lw-user-check {
    font-size: 20px;
    background-color: white;
  }
`;

export default function FollowButton({
  name, followed, onToggle, lessUnfollow,
}) {
  const onClick = e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (_.get(window, 'Livewire.currentUser.id')) {
      onToggle();
    } else if (name) {
      window.location = `/sign_up?return_to_section=${name}`;
    } else {
      window.location = '/sign_up';
    }
  };

  const scrollToSection = React.useCallback(() => {
    scroller.scrollTo(name, {
      // without this offset, the button is at the top edge of the screen,
      // which is underneath the application navbar
      offset: -200,
      duration: 1500,
      smooth: 'easeInOutQuint',
    });
  }, [name]);

  React.useEffect(() => {
    if (name && window.location.hash === `#${name}`) {
      scrollToSection();
    }
  }, [name, scrollToSection]);

  const iconCls = {
    'icon-lw-user-check': lessUnfollow && followed,
    'icon-lw-minus': !lessUnfollow && followed,
    'icon-lw-plus': !followed,
  };

  return (
    <Button
      {...{ name, onClick }}
      type="button"
      className={classNames('btn btn-primary', { pale: lessUnfollow && followed })}
    >
      <span className={classNames('icon-lw', iconCls)} />
      <span>{followed ? 'Following' : 'Follow'}</span>
    </Button>
  );
}

FollowButton.propTypes = {
  lessUnfollow: PropTypes.bool,
  name: PropTypes.string,
  followed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

FollowButton.defaultProps = {
  lessUnfollow: false,
  name: null,
};
